"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DynamicComponentPropertiesModel = /** @class */ (function () {
    /**
     * @property componentSelector Selector of the component to be loaded
     * @property component Main component class to be loaded
     * @property moduleLoaderFunction Function returning Component's module
     * @property componentInputs Created component's inputs values
     */
    function DynamicComponentPropertiesModel(componentSelector, component, moduleLoaderFunction, componentInputs, title) {
        this.componentSelector = componentSelector;
        this.component = component;
        this.moduleLoaderFunction = moduleLoaderFunction;
        this.componentInputs = componentInputs;
        this.title = title;
    }
    return DynamicComponentPropertiesModel;
}());
exports.DynamicComponentPropertiesModel = DynamicComponentPropertiesModel;
//# sourceMappingURL=dynamic-component-properties.model.js.map